import { HStack } from '@/components/ui/hstack'
import { Menu, MenuItem, MenuItemLabel } from '@/components/ui/menu'
import { Pressable } from '@/components/ui/pressable'
import { Text } from '@/components/ui/text'
import { CheckIcon, ChevronDownIcon } from 'lucide-react-native'
import { useColorScheme } from 'nativewind'
import type { TradeFilterChipProps } from './TradeFilterChip.types'

export default function TradeFilterChip<T extends string>({ options, value, onChange }: TradeFilterChipProps<T>) {
  const { colorScheme } = useColorScheme()
  const labelColor = colorScheme === 'dark' ? '#FFFFFF' : '#000000'
  const label = options.find(option => option.value === value)?.label ?? ''

  return (
    <Menu
      placement="bottom left"
      trigger={triggerProps => (
        <Pressable {...triggerProps} className="rounded-full bg-secondary-system-background px-3 py-[7px]">
          <HStack space="xs" className="items-center">
            <Text size="sm" className="font-medium text-label">
              {label}
            </Text>
            <ChevronDownIcon size={14} color={labelColor} />
          </HStack>
        </Pressable>
      )}
    >
      {options.map(option => (
        <MenuItem key={option.value} textValue={option.label} onPress={() => onChange(option.value)}>
          <MenuItemLabel>{option.label}</MenuItemLabel>
          {option.value === value && <CheckIcon size={16} color={labelColor} style={{ marginLeft: 'auto' }} />}
        </MenuItem>
      ))}
    </Menu>
  )
}
